export default __webpack_public_path__ + "images/b71ad775bed4358c66eb9867c9331358-film_and_media.webp";